export enum ActionTypes {
    SELECT_ALL_ACTIONS_WITH_LARGE_PAYLOAD_CLICKED,
    UPDATE_ALL_ACTIONS,
    UPDATE_ACTIONS_WITH_LARGE_PAYLOADS,
    UPDATE_CALCULATE_BUTTON_TEXT,
    UPDATE_CALCULATE_CLICKED,
    UPDATE_ERROR_MESSAGE,
    UPDATE_REPEATING_ACTIONS,
    UPDATE_REPEATING_ACTIONS_ITERATIONS,
    UPDATE_MONTHLY_RUNS,
    UPDATE_OPERATION_COUNT_DATA,
    UPDATE_WORKFLOW_DEFINITION,
    UPDATE_WORKFLOW_HAS_LARGE_ACTIONS
  }

export interface IAction {
  type: ActionTypes,
  payload: any
}